module.exports = __webpack_public_path__ + "static/media/private-room-icon.20e5f143.svg";